import React from 'react'
import styled from 'styled-components'
import breakpoint from 'styled-components-breakpoint'

const Colors = {
  rosado: '#ed174b',
  morado: '#b4477c',
  verde: '#008d36',
  grisClaro: '#888',
  grisExtraClaro: '#BBB',
  grisOscuro: '#444',
}

const CalcContainer = styled.div`
  padding: 0 40px 0;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;

  ${breakpoint('tablet')`
    max-width: 800px;
    margin: 0 auto;
  `}
`

const CalcRow = styled.div`
  margin: 40px 0;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;

  .thumb-button {
    width: 30px;
    height: 30px;
  }

  .track {
    height: 6px;
  }

  .track-before,
  .thumb-button {
    &.rosado {
      background-color: ${Colors.rosado};
    }
    &.morado {
      background-color: ${Colors.morado};
    }
    &.verde {
      background-color: ${Colors.verde};
    }
  }

  .track-after {
    background-color: ${Colors.grisClaro};
  }

  .rosado {
    color: ${Colors.rosado};
  }
  .morado {
    color: ${Colors.morado};
  }
  .verde {
    color: ${Colors.verde};
  }
`

const CalcTitular = styled.div`
  font-size: 18px;
  flex: none;
  width: 50%;
  font-weight: bold;
  margin-bottom: 15px;
`

const CalcValueContainer = styled.div`
  font-size: 20px;
  flex: none;
  width: 50%;
  text-align: right;
  color: ${props => Colors[props.color]};
  font-weight: 700;
  line-height: 0.8em;
  margin-bottom: 15px;

  span {
    font-size: 12px;
    color: ${Colors.grisClaro};
    font-weight: 400;
  }
`

const CalcTotal = styled.div`
  font-size: 20px;
  margin: 20px 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  color: ${Colors.grisOscuro};
  & > div {
    flex: 1 1;
    flex-basis: 50%;
    width: 50%;
  }
`

const CalcTotalValue = styled.div`
  font-size: 40px;
  text-align: right;
  flex: 1 1;
  color: ${Colors.grisOscuro};
  font-weight: bold;
`

const SliderOuterContainer = styled.div`
  flex: none;
  width: 100%;
  height: 20px;
  position: relative;
`

const ScaleContainer = styled.div`
  position: absolute;
  top: 3px;
  left: 0;
  display: flex;
  width: 100%;
  height: 20px;
  flex-wrap: no-wrap;
`

const ScalePoint = styled.div`
  flex: none;
  width: 25%;
  color: ${Colors.grisClaro};
  height: 8px;
  border-left: solid 2px #e3e3e3;
  box-sizing: border-box;

  &:last-of-type {
    width: 0;
    margin-left: -2px;
  }

  & > div {
    display: inline-block;
    transform: translateX(-50%);
    color: ${Colors.grisExtraClaro};
    padding-top: 15px;
    font-size: 13px;
  }
`

const SliderContainer = ({ children }) => (
  <SliderOuterContainer>
    <div>{children}</div>
    <ScaleContainer>
      <ScalePoint>
        <div>$0</div>
      </ScalePoint>
      <ScalePoint>
        <div>$500</div>
      </ScalePoint>
      <ScalePoint>
        <div>$1000</div>
      </ScalePoint>
      <ScalePoint>
        <div>$1500</div>
      </ScalePoint>
      <ScalePoint>
        <div>$2000</div>
      </ScalePoint>
    </ScaleContainer>
  </SliderOuterContainer>
)

const CalcValue = ({ value, color }) => (
  <CalcValueContainer color={color}>
    ${value}
    <br />
    <span>de consumo</span>
  </CalcValueContainer>
)

export {
  CalcContainer,
  CalcTitular,
  CalcRow,
  CalcValue,
  CalcTotal,
  CalcTotalValue,
  SliderContainer,
}
